import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { MaintenanceGuard } from './maintenance.guard';

export const canActivateMaintenanceFn: CanActivateFn = (route: ActivatedRouteSnapshot) =>
  inject(MaintenanceGuard).canActivate(route);
